import React from 'react';
import { connect } from 'react-redux';
import { is } from 'immutable';
import Spinner from '~/components/Spinner';
import { auth } from '~/actions/user';
import { joinRoom, send } from '~/actions/rooms';
import { init, list, handleDashboardCmd } from '~/actions/dashboards';

import DrawDashboard from './drawDashboard';

import Styles from './style.scss';

class DashboardInit extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
    this.state = { error: undefined, loggedin: false };
  }
  componentDidMount() {
    this.login();
  }

  componentWillReceiveProps(newProps) {
    console.log('--->', newProps);

    if (!is(newProps.dashboardCmds, this.props.dashboardCmds)) {
      // for now handle first and remove from queue
      this.receiveCmd(newProps.dashboardCmds);
    }
    const { dashboardId } = newProps;
    if (
      dashboardId &&
      newProps.dashboardItems.size > 0 &&
      !newProps.dashboardItems.getIn([dashboardId, 'shortId'], false)
    ) {
      console.log('Have a dashboard id and some items');
      this.removeCookie().then(() => {
        document.location.reload();
      });
    }
    if (!dashboardId) {
      init(this.props.dispatch, this.context.apiClient);
    }
  }

  componentWillUnmount() {
    clearInterval(this.heartBeatTimer);
  }

  login() {
    auth(this.props.dispatch, this.context.apiClient, {
      username: 'system',
      password: 'fsWQgjw8K/u/mgWa2vSp'
    })
      .then(() => {
        console.log('Good login');
        this.setState({ loggedin: true });
        const { dashboardId } = this.props;
        if (!dashboardId) {
          init(this.props.dispatch, this.context.apiClient);
        } else {
          joinRoom(this.props.dispatch, this.context.apiClient, dashboardId);
          list(this.props.dispatch, this.context.apiClient);
        }
        this.sendHeartBeat();
      })
      .catch(err => {
        console.log(err);
        this.setState({ error: err.error ? err.error : JSON.stringify(err) });
      });
  }
  sendHeartBeat() {
    this.heartBeatTimer = setInterval(() => {
      const { dashboardId, dashboardItems } = this.props;
      const shortId = dashboardItems.getIn([dashboardId, 'shortId'], false);
      if (shortId) {
        send(
          this.props.dispatch,
          this.context.apiClient,
          'admin',
          'heartbeat',
          { shortId }
        );
      }
    }, 10000);
  }

  removeCookie() {
    this.props.dispatch({
      type: 'COOKIE_REMOVE',
      key: 'dashboardId'
    });
  }

  receiveCmd(cmd) {
    const curCmd = cmd.get(0);
    if (curCmd) {
      switch (curCmd.payload.action) {
        case 'reload':
          // reload service
          list(this.props.dispatch, this.context.apiClient);
          break;

        default:
          console.log('Unhandled dashboard cmd', curCmd.payload);
          break;
      }
      handleDashboardCmd(this.props.dispatch, 0);
    }
  }

  renderLoader() {
    return (
      <div className={Styles.content}>
        <Spinner />
      </div>
    );
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <div className={Styles.content}>
          {error}
        </div>
      );
    }

    const { username, dashboardId, dashboardItems } = this.props;
    if (!username || !dashboardId) {
      return this.renderLoader();
    }

    const shortId = dashboardItems.getIn([dashboardId, 'shortId'], false);
    if (!shortId) {
      return this.renderLoader();
    }

    const dashboardInfo = dashboardItems.getIn([dashboardId, 'info'], false);
    if (dashboardInfo) {
      return <DrawDashboard dashboardId={dashboardId} />;
    }

    return (
      <div className={Styles.content}>
        <div className={Styles.deviceId}>{shortId}</div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  username: state.getIn(['user', 'self', 'username'], false),
  dashboardId: state.getIn(['cookie', 'dashboardId'], false),
  dashboardItems: state.getIn(['dashboards', 'item'], false),
  dashboardCmds: state.getIn(['dashboards', 'cmd'], false)
});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps)(DashboardInit);



// WEBPACK FOOTER //
// ./app/pages/DashboardInit/index.js